import $ from 'jquery';

class ImageGridModal {
    constructor() {
        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $(document).on('click', '.js-modal-trigger', this.openModal);
        $(document).on('click', '.js-modal-close', this.closeModal);
        $(document).on('click', '.js-modal-overlay', this.closeModal);
        $(document).keyup((e) => {
            if (e.key === "Escape") {
                this.closeModal();
            }
        });
    }

    openModal(e) {
        e.preventDefault();
        const modalId = $(this).data('modal-target');
        $(modalId).addClass('active');
        $(`${modalId}-overlay`).addClass('active');
        $('body').css('overflow', 'hidden');
    }

    closeModal() {
        $('.image-grid-modal__modal').removeClass('active');
        $('.image-grid-modal__overlay').removeClass('active');
        $('body').css('overflow', '');
    }
}

export default ImageGridModal;
